import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minutesToHours',
})
export class MinutesToHoursPipe implements PipeTransform {
  transform(value: number): string {
    if (value > 0 && value / 60 < 1) {
      return value + 'm';
    } else if (value % 60 === 0) {
      return value / 60 + 'h';
    } else {
      return Math.trunc(value / 60) + 'h ' + (value % 60) + 'm';
    }
  }
}
